import { http } from './http';

/** 직원 — admin 공용 테이블을 읽기만. 이름을 띄울 때 쓴다 */
export interface Employee { id: number; name: string; position: string | null; department: string | null }

let cache: Promise<Employee[]> | null = null;
export const employeeApi = {
  list(): Promise<Employee[]> {
    if (!cache) cache = http.get<Employee[]>('/employees').catch((e) => { cache = null; throw e; });
    return cache;
  },
};

export const nameOf = (xs: Employee[], id: number | null | undefined) => (id == null ? null : xs.find((e) => e.id === id)?.name ?? `#${id}`);
